import config from './MdbConfig.js';

export const getexpirationTime = time => {
  return new Date(new Date().getTime() + time * 1000);
};

export const getUserFromEmail = mail => {
  return mail.substring(0, mail.lastIndexOf('@'));
};

export const checkoutUserStatus = (isSignup, apiKey) => {
  return !isSignup
    ? config.SIGN_UP_USER_PARAMS + apiKey
    : config.VERIFY_PASSWORD + apiKey;
};

export const getAuthData = (email, password) => {
  return {
    email: email,
    password: password,
    returnSecureToken: true
  };
};

export const reduceGenres = response => {
  return response.genres.reduce(
    (acc, cur) => ({
      ...acc,
      [cur.id]: cur.name
    }),
    {}
  );
};

export const updateObject = (oldObject, updatedProperties) => {
  return {
    ...oldObject,
    ...updatedProperties
  };
};

const parseYear = (movie, tv) => {
  const year = [movie, tv]
    .filter(Boolean)
    .join('')
    .split('-')[0];
  return parseFloat(year);
};

const parseTitle = (title, name) => {
  return [title, name].filter(Boolean).join('');
};

const parseTypeAheadImg = image =>
  !image ? config.NO_POSTER_IMG : config.LAZY_IMG_CONF + image;

export const reduceTitles = data => {
  return data.reduce(
    (acc, cur) => ({
      ...acc,
      ...cur
    }),
    {}
  );
};

const cutReview = (review, words, dots = '...') => {
  return (
    review
      .split(' ')
      .slice(0, words)
      .join(' ') + dots
  );
};

export const mapPersonImages = response => {
  return {
    heroImg: response.profiles.length
      ? config.ORIGINAL_POSTER +
        response.profiles[Math.floor(Math.random() * response.profiles.length)]
          .file_path
      : config.DEFAULT_PERSON_PHOTO
  };
};

export const mapPersonDetails = response => {
  return {
    name: response.name || '',
    cardImg: config.LAZY_IMG_CONF_MAIN + response.profile_path || '',
    biography: cutReview(response.biography, 100) || '',
    birthday: response.birthday || '',
    id: response.id,
    place_of_birth: response.place_of_birth || ''
  };
};

export const mapPersonCredits = response => {
  return {
    cast: response.cast.slice(0, 10).map(el => {
      return {
        img: config.LAZY_IMG_CONF_MAIN + el.poster_path || '',
        char: el.character,
        id: el.id,
        overview: cutReview(el.overview, 100),
        title: el.title,
        type: el.media_type
      };
    })
  };
};

export const mapDetails = response => {
  return {
    details: {
      id: response.id,
      genres: response.genres
        .map(genre => genre.name)
        .slice(0, 2)
        .join(' / '),
      title: response.original_name || response.original_title,
      overview: response.overview,
      poster: config.ORIGINAL_POSTER + response.backdrop_path,
      cardImg: config.LAZY_IMG_CONF_MAIN + response.poster_path,
      release_date: (response.first_air_date || response.release_date)
        .split('-')
        .slice(0, 1)
        .join(''),
      status: response.status,
      rating: response.vote_average
    }
  };
};

export const mapCredits = response => {
  return {
    cast: response.cast
      .filter(photo => photo.profile_path)
      .map(el => {
        return {
          char: el.character,
          name: el.name,
          photo: config.MOVIES_IMG_CONF + el.profile_path,
          id: el.id
        };
      })
  };
};

export const mapTrailers = response => {
  return {
    trailers: response.results.map((el, _) => {
      return {
        trailer_src: config.TRAILER_CONFIG + el.key,
        trailer_id: el.id
      };
    })
  };
};

export const mapReviews = response => {
  return {
    reviews: response.results.map((el, _) => {
      return {
        content: cutReview(el.content, 60),
        url: el.url,
        id: el.id
      };
    })
  };
};

export const mapMultiData = response => {
  const { results } = response;
  return {
    pages: response.total_pages,
    results: filterResults(results).map((el, i) => {
      return {
        index: i,
        imgSrc: !el.poster_path
          ? config.DUMMY_IMAGE_SEARCH_SOURCE
          : config.MOVIES_IMG_CONF + el.poster_path,
        id: el.id,
        title: parseTitle(el.title, el.name),
        rating: el.vote_average,
        genres: el.genre_ids,
        type: (el.media_type = !el.media_type ? 'tv' : el.media_type),
        year: isNaN(parseYear(el.release_date, el.first_air_date))
          ? 'Unknown'
          : parseYear(el.release_date, el.first_air_date),
        typeAheadImg: parseTypeAheadImg(el.poster_path)
      };
    })
  };
};

const filterResults = results => {
  return results.filter(el => el.poster_path);
};

const sortRating = results => {
  return results.sort((a, b) => b.vote_average - a.vote_average);
};

export const mapMovies = response => {
  return response.results.map((el, i) => {
    return {
      index: i,
      imgSrc: config.MOVIES_IMG_CONF + el.poster_path,
      id: el.id,
      title: el.title,
      rating: el.vote_average,
      genres: el.genre_ids,
      lazyImg: config.LAZY_IMG_CONF_MAIN + el.backdrop_path,
      type: 'movie'
    };
  });
};

export const mapTvs = response => {
  return sortRating(response.results).map((el, i) => {
    return {
      index: i,
      imgSrc: config.MOVIES_IMG_CONF + el.poster_path,
      id: el.id,
      title: el.name,
      rating: el.vote_average,
      genres: el.genre_ids,
      lazyImg: config.LAZY_IMG_CONF + parseTypeAheadImg(el.backdrop_path),
      type: 'tv'
    };
  });
};

export const mapTrending = response => {
  return response.map((el, i) => {
    return {
      index: i,
      imgSrc: config.TRENDING_IMG_CONF + el.backdrop_path,
      id: el.id,
      title: el.original_title,
      rating: el.vote_average,
      genres: el.genre_ids,
      lazyImg: config.LAZY_IMG_CONF + el.backdrop_path
    };
  });
};
